import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api, extractError } from '@/lib/api.js';

export type ChatMsg = { role: 'user' | 'assistant'; content: string; sources?: string[] };

export function useAiChat(task: 'CHAT_ALUNO' | 'CHAT_MENTOR' = 'CHAT_ALUNO') {
  const [messages, setMessages] = useState<ChatMsg[]>([]);
  const [input, setInput] = useState('');

  const send = useMutation({
    mutationFn: async (text: string) => {
      const next: ChatMsg[] = [...messages, { role: 'user', content: text }];
      const { data } = await api.post<{ content: string; sources?: string[] }>('/ai/chat', {
        task,
        messages: next.map((m) => ({ role: m.role, content: m.content })),
      });
      return { user: text, reply: data.content, sources: data.sources };
    },
    onSuccess: ({ user, reply, sources }) => {
      setMessages((m) => [
        ...m,
        { role: 'user', content: user },
        { role: 'assistant', content: reply, sources },
      ]);
      setInput('');
    },
  });

  function submit() {
    const text = input.trim();
    if (!text || send.isPending) return;
    send.mutate(text);
  }

  return {
    messages,
    input,
    setInput,
    submit,
    send,
    error: send.error ? extractError(send.error).message : null,
  };
}
